'use strict';

import axios from "axios";
import {cardsData, isDesktop, isMobile, settingsData} from "../../settings";
import {CardTypes} from "../../common";
import {
    changeLangToCurrent,
    getCurrentLangDirection,
} from '../components/langSwitcher/langSwitcher';
import Notiflix from 'notiflix';
import {BaseElement} from "../interfaces/BaseElement";

Notiflix.Notify.init({
    width:'100%',
    timeout:10000,
    messageMaxLength:1000,
    zindex:100,
    opacity:1,
    position:'right-top',
    clickToClose: true,
    pauseOnHover: true,
    cssAnimation: true,
    cssAnimationDuration: 500,
    cssAnimationStyle: 'from-top',
    plainText: false,
    ID: 'notiflix',
    info:{
        background: '#519af8',
        notiflixIconColor: 'rgba(255,255,255,1)'
    }
});

let statisticTimeOuts = [];

export function changeNotiflixNotifyPosition () {
    const dir = getCurrentLangDirection();
    const notiflix = document.querySelector('#NotiflixNotifyWrap');

    if (!notiflix)
        return;

    Notiflix.Notify.merge({
        position: isDesktop ? 'left-top' : (dir === 'ltr') ? 'right-top' : 'left-top',
        rtl: (dir !== 'ltr'),
        info:{
            background: '#519af8'
        }
    });

    for (let info of notiflix.children){
        if (dir === 'rtl'){
           info.classList.add('nx-rtl-on')
        } else {
           info.classList.remove('nx-rtl-on')
        }
    }
    notiflix.style.inset = dir === 'rtl' ? '10px auto auto 10px' : '10px 10px auto auto';
}

export function updateNotiflixNotifyDirection () {
    const dir = getCurrentLangDirection();
    const notiflix = document.querySelector('#NotiflixNotifyWrap');

    if (!notiflix)
        return;

    Notiflix.Notify.merge({
        rtl: (dir !== 'ltr'),
    });

    for (let info of notiflix.children){
        if (dir === 'rtl'){
           info.classList.add('nx-rtl-on')
        } else {
           info.classList.remove('nx-rtl-on')
        }
    }
}

export function closeNotifications () {
    statisticTimeOuts.forEach(timeOut => clearTimeout(timeOut));
    statisticTimeOuts = [];
    const notiflix = document.querySelector('#NotiflixNotifyWrap');
    if (!notiflix)
        return;
    
    notiflix.remove();
}

const optionsStatistic = {
    propertyId: config.features.googleAnalytics?.propertyId,
    types: ['card-view', 'favorites']
}

export const getGoogleAnalyticsData = async () => {
    if (!config.features.googleAnalytics?.active || config.features.googleAnalytics?.notification?.length === 0)
        return;
    console.warn('GET DATA FROM GA');

    const {protocol, host} = location;
    const daysAgo = config.features.googleAnalytics.daysAgo || 2;
    for (let type of optionsStatistic.types){
        let requestURL = `${protocol}//${host}/?analytics=${type}&id=${optionsStatistic.propertyId}`;
        if(type == 'card-view'){
            requestURL += `&days_ago=${daysAgo}`;
        }
        const response = await axios.get(requestURL);
        settingsData.statisticData[type] = response.data;
    }
}

export const createPopUp = () => {
    const statisticBlock = new BaseElement()
      .addClass(`${CardTypes.Options}-card__statistic-container`)
      .DOMElement;
    const statisticInterestedBlock = new BaseElement()
      .addClass(`${CardTypes.Options}-card__statistic-container-stat-box`)
      .DOMElement;
    const statisticFavoritesBlock = new BaseElement()
      .addClass(`${CardTypes.Options}-card__statistic-container-stat-box`)
      .DOMElement;
    new BaseElement('span')
      .addClass(`${CardTypes.Options}-card__statistic-container_interest`, 'language-string')
      .addAttribute('data-dictionary', 'statInterestedText')
      .innerHtml(changeLangToCurrent('statInterestedText'))
      .appendTo(statisticInterestedBlock);
    new BaseElement('span')
      .addClass(`${CardTypes.Options}-card__statistic-container_favorites`, 'language-string')
      .addAttribute('data-dictionary', 'statFavoritesText')
      .innerHtml(changeLangToCurrent('statFavoritesText'))
      .appendTo(statisticFavoritesBlock);

    return {
        statisticBlock,
        statisticInterestedBlock,
        statisticFavoritesBlock
    }
}

export const showStatisticPopUp = (args) => {
    const { cardBox, object } = args;

    if (isMobile || cardsData.cardMode.isAmenities || cardsData.cardMode.isUnavailable)
        return;
    if (!cardBox)
        return;

    const {statisticData} = settingsData;
    const popUpArray = [];

    if (!Object.keys(statisticData).length)
        return;

    const notifications = config.features.googleAnalytics.notification;
    const dir = getCurrentLangDirection();
    Notiflix.Notify.merge({
        position: isDesktop ? 'left-top' : (dir === 'ltr') ? 'right-top' : 'left-top',
        rtl: (dir !== 'ltr')
    });
    const cardView = Array.isArray(statisticData['card-view']) && notifications?.find(notification => notification.type === 'card-view' && notification.active) ? statisticData['card-view'].find(data => Number(data.bmbyPropId) === object.bmbyPropID) : undefined;
    const favorites = Array.isArray(statisticData['favorites']) && notifications?.find(notification => notification.type === 'favorites' && notification.active) ? statisticData['favorites'].find(data => Number(data.bmbyPropId) === object.bmbyPropID) : undefined;
    const {statisticInterestedBlock, statisticFavoritesBlock, statisticBlock} = createPopUp();

    if (cardView) {
        statisticInterestedBlock.insertAdjacentHTML('afterbegin', `<span class='num'>${cardView.count}</span>`);
        const copyInterested = statisticBlock.cloneNode(true);
        copyInterested.appendChild(statisticInterestedBlock);
        popUpArray.push(copyInterested);
    }

    if (favorites) {
        statisticFavoritesBlock.insertAdjacentHTML('afterbegin', `<span class='num'>${favorites.count}</span>`);
        const copyFavorite = statisticBlock.cloneNode(true);
        copyFavorite.appendChild(statisticFavoritesBlock);
        popUpArray.push(copyFavorite);
    }

    popUpArray.forEach((popup,index) =>{
        const timeOut = setTimeout(()=> {
            if (cardBox) Notiflix.Notify.info(`${popup.innerHTML}`);
        },index * 1000);
        addStatisticTimeOut(timeOut);
    });
}

export function addStatisticTimeOut (timeOut) {
    statisticTimeOuts.push(timeOut);
}
